// import { RouteRecordRaw } from 'vue-router'

import LoginView from "../views/auth/LoginView";
import RegisterView from "../views/auth/NormalRegisterView";
import ForgetPasswordView from "../views/auth/ForgetPasswordView";
import ResetPasswordView from "../views/auth/ResetPasswordView";
import DashboardView from "../views/DashboardView";
import SitesAndDevicesView from "../views/SitesAndDevicesView";
// import AppsLibraryView from'../views/AppsLibraryView'
// import DeviceLogsView from'../views/DeviceLogsView'
import NotFoundView from "../views/NotFoundView";
import AccessDeniedView from "../views/AccessDeniedView";
// import AgentImagesView from "@/views/AgentImagesView.vue";
import CompaniesListView from "../views/CompaniesListView";
import CompanyDetailsView from "../views/CompanyDetailsView";
import UsersView from "../views/UsersView";
import ConfigurationsView from "../views/ConfigurationsView";
import GeneralSettingsView from "../views/GeneralSettingsView";
import InboxView from "../views/InboxView";
// import JobsView from'../views/JobsView'
import configSettings from "../components/configurations/configSettings";
// import RemoteControlView from'../components/kiosks/RemoteControlView.vue'
import VoiceChatView from "@/views/VoiceChatView.vue";
import router from ".";
import { resolveLandingLink } from "../components/sideMenuItems.js";
import { safeParse } from "../utils/accessControl.js";
// import Documents from "@/views/Documents.vue";
// import Agents from "@/views/Agents.vue";
import AgentsView from "@/views/AgentsView.vue";
import DataSourceView from "@/views/DataSourceView.vue";
import createDataSource from "@/components/dataCollection/createDataSource.vue";
import DataMappingFilesView from "@/views/DataMappingFilesView.vue";
import FileDataMappingView from "@/components/dataMapping/FileDataMappingView.vue";
import TestAgentView from "@/views/TestAgentView.vue";
import AgentDocuments from "../views/AgentDocuments.vue";
// import NewLayoutView from "../views/NewLayoutView.vue";
import testAgent from "@/components/agents/testAgent.vue";
import IntegrationsView from "@/views/IntegrationsView.vue";
import JobsView from "@/views/JobsView.vue";
import AgentInstructionsView from "@/views/AgentInstructionsView.vue";
import createAgentInstructions from "@/components/agentInstructions/agentInstructions.vue";
import SessionHistoryView from "@/views/SessionHistoryView.vue";
import ThemesView from "@/views/ThemesView.vue";
import themeBuilder from "@/components/themes/themeBuilder.vue";
import ThemeAssignmentsView from "@/views/ThemeAssignmentsView.vue";
import MediaLibraryView from "@/views/MediaLibraryView.vue";
import createNewMedia from "@/components/mediaLibrary/createNewMedia.vue";
import CampaignsView from "@/views/CampaignsView.vue";
import createCampaign from "@/components/campaigns/createCampaign.vue";
import ConversationsAnalyticsView from "@/views/ConversationsAnalyticsView.vue";
import AgentAnalyticsView from "@/views/AgentAnalyticsView.vue";
import MessagesAnalyticsView from "@/views/MessagesAnalyticsView.vue";
import DataLibraryView from "@/views/DataLibraryView.vue";
import uploadFiles from "@/components/filesMangement/uploadFiles.vue";
import AttachmentsAnalyticsView from "@/views/AttachmentsAnalyticsView.vue";
import EngagementAnalyticsView from "@/views/EngagementAnalyticsView.vue";
import AgentsAnalyticsView from "@/views/AgentsAnalyticsView.vue";
import AttachmentsBoardView from "@/views/AttachmentsBoardView.vue";
import DevicesAnalyticsView from "@/views/DevicesAnalyticsView.vue";
import CartAnalyticsView from "@/views/CartAnalyticsView.vue";
import OverviewView from "@/views/OverviewView.vue";

const protectedRoutes = (routeTo, routeFrom, next) => {
  let user = null;
  let currentCompany = null;
  try {
    user = JSON.parse(localStorage.getItem("user"));
    currentCompany = JSON.parse(localStorage.getItem("currentCompany"));
  } catch (e) {
    console.log(e);
  }

  if (!user || !currentCompany) {
    localStorage.clear();
    router.push("/login");
    return;
  }
  next();
};

const beforeEnterAuth = (routeTo, routeFrom, next) => {
  let user = null;
  try {
    user = JSON.parse(localStorage.getItem("user"));
  } catch (e) {
    console.log(e);
  }
  if (user) {
    router.push("/");
    return;
  }
  next();
};

const beforeEnterAllCompanies = (routeTo, routeFrom, next) => {
  let userDetails = null;
  let currentCompany = null;
  try {
    userDetails = JSON.parse(localStorage.getItem("user"));
    currentCompany = JSON.parse(localStorage.getItem("currentCompany"));
  } catch (e) {
    console.log(e);
  }

  const superAdminEmail = process.env.VUE_APP_SUPER_ADMIN_EMAIL;

  if (userDetails) {
    const isSuperAdmin = userDetails.user?.email === superAdminEmail;
    const hasMultipleCompanies = userDetails.user?.companies?.length > 1;

    if (!currentCompany && !isSuperAdmin && !hasMultipleCompanies) {
      localStorage.clear();
      router.push("/login");
      return;
    }

    if (!isSuperAdmin && !hasMultipleCompanies) {
      router.push("/");
      return;
    }
  } else {
    router.push("/login");
    return;
  }
  next();
};

const routes = [
  {
    path: "/login",
    name: "LoginView",
    component: LoginView,
    beforeEnter: beforeEnterAuth,
    meta: {
      title: "Login",
    },
  },
  {
    path: "/register",
    name: "RegisterView",
    component: RegisterView,
    beforeEnter: beforeEnterAuth,
    meta: {
      title: "Register",
    },
  },
  {
    path: "/forget-password",
    name: "ForgetPasswordView",
    component: ForgetPasswordView,
    beforeEnter: beforeEnterAuth,
    meta: {
      title: "Forget Password",
    },
  },
  {
    path: "/reset-password/:code/:email",
    name: "ResetPasswordView",
    component: ResetPasswordView,
    beforeEnter: beforeEnterAuth,
    meta: {
      title: "Reset Password",
    },
  },
  {
    path: "/",
    redirect: () =>
      resolveLandingLink(
        safeParse(localStorage.getItem("user")),
        process.env.VUE_APP_SUPER_ADMIN_EMAIL,
      ),
    beforeEnter: protectedRoutes,
  },
  {
    path: "/dashboard",
    name: "DashboardView",
    component: DashboardView,
    beforeEnter: protectedRoutes,
    meta: {
      title: "Dashboard",
    },
  },
  {
    path: "/ai-voice-chat/:agentId",
    name: "VoiceChatView",
    component: VoiceChatView,
    meta: {
      title: "Voice Chat",
    },
  },
  {
    path: "/agents-management",
    name: "AgentsView",
    component: AgentsView,
    beforeEnter: protectedRoutes,
    meta: {
      title: "Agents Management",
      requiresAuth: true,
      breadcrumb: [
        { text: "Overview", to: "/overview" },
        { text: "Agents List", active: true },
      ],
    },
  },
  {
    path: "/agents-management/:id/test",
    name: "testAgent",
    component: testAgent,
    beforeEnter: protectedRoutes,
    meta: {
      title: "Test Agent",
      requiresAuth: true,
    },
  },
  {
    path: "/agents-test",
    name: "TestAgentView",
    component: TestAgentView,
    beforeEnter: protectedRoutes,
    meta: {
      title: "Test Agent",
      requiresAuth: true,
      breadcrumb: [
        { text: "Overview", to: "/overview" },
        { text: "Agents Management", to: "/agents-management" },
        { text: "Agents Test", active: true },
      ],
    },
  },
  {
    path: "/data-source",
    name: "DataSourceView",
    component: DataSourceView,
    beforeEnter: protectedRoutes,
    meta: {
      title: "Data Sources",
      requiresAuth: true,
      breadcrumb: [
        { text: "Overview", to: "/overview" },
        { text: "Knowledge Base" },
        { text: "Data Source", active: true },
      ],
    },
  },
  {
    path: "/data-source/create",
    name: "createDataSource",
    component: createDataSource,
    beforeEnter: protectedRoutes,
    meta: {
      title: "Create Data Source",
      requiresAuth: true,
    },
  },
  {
    path: "/data-source/:id",
    name: "editDataSource",
    component: createDataSource,
    beforeEnter: protectedRoutes,
    meta: {
      title: "Edit Data Source",
      requiresAuth: true,
    },
  },
  {
    path: "/data-mappings",
    name: "DataMappingFilesView",
    component: DataMappingFilesView,
    beforeEnter: protectedRoutes,
    meta: {
      title: "Data Mapping",
      requiresAuth: true,
    },
  },
  {
    path: "/data-mappings/:id/files",
    name: "FileDataMappingView",
    component: FileDataMappingView,
    beforeEnter: protectedRoutes,
    meta: {
      title: "File Data Mapping",
      requiresAuth: true,
    },
  },
  //   {
  //   path: '/data-source/:id/mapping',
  //   name: 'FileDataMappingView',
  //   component: FileDataMappingView,
  //   beforeEnter: protectedRoutes,
  //   meta: {
  //     title: 'Data Mapping',
  //     requiresAuth: true
  //   }
  // },
  {
    path: "/agents/:agentId/:agentName/documents",
    name: "AgentDocuments",
    component: AgentDocuments,
    beforeEnter: protectedRoutes,
    meta: {
      title: "Agent Documents",
      requiresAuth: true,
    },
    props: (route) => ({
      agentId: route.params.agentId,
      agentName: route.params.agentName,
    }),
  },
  // Shown when the capability guard refuses a route. Deliberately NOT gated by
  // a capability itself, or refusing access would recurse.
  {
    path: "/403",
    name: "AccessDeniedView",
    component: AccessDeniedView,
    meta: {
      title: "Access Denied",
    },
  },
  // Catch-all route - MUST be at the end
  {
    path: "/:catchall(.*)*",
    name: "NotFoundView",
    component: NotFoundView,
  },
  {
    path: "/sites-devices",
    name: "SitesAndDevicesView",
    component: SitesAndDevicesView,
    beforeEnter: protectedRoutes,
    meta: {
      title: "Stores & Kiosks",
      breadcrumb: [
        { text: "Overview", to: "/overview" },
        { text: "Sites & Devices", active: true },
      ],
    },
  },
  {
    path: "/users",
    name: "UsersView",
    component: UsersView,
    beforeEnter: protectedRoutes,
    meta: {
      title: "Users",
      breadcrumb: [
        { text: "Overview", to: "/overview" },
        { text: "Users", active: true },
      ],
    },
  },
  {
    path: "/integrations",
    name: "IntegrationsView",
    component: IntegrationsView,
    beforeEnter: protectedRoutes,
    meta: {
      title: "Integrations",
    },
  },
  {
    path: "/jobs",
    name: "JobsView",
    component: JobsView,
    beforeEnter: protectedRoutes,
    meta: {
      title: "Jobs",
      breadcrumb: [
        { text: "Overview", to: "/overview" },
        { text: "Knowledge Base" },
        { text: "Jobs", active: true },
      ],
    },
  },
  {
    path: "/agents-instructions",
    name: "AgentInstructionsView",
    component: AgentInstructionsView,
    beforeEnter: protectedRoutes,
    meta: {
      title: "Agent Instructions",
      breadcrumb: [
        { text: "Overview", to: "/overview" },
        { text: "Agents Management", to: "/agents-management" },
        { text: "Agents Instructions", active: true },
      ],
    },
  },
  {
    path: "/agent-instructions",
    name: "createAgentInstructionsView",
    component: createAgentInstructions,
    beforeEnter: protectedRoutes,
    meta: {
      title: "Create Agent Instructions",
    },
  },
  {
    path: "/conversations-analytics",
    name: "ConversationsAnalyticsView",
    component: ConversationsAnalyticsView,
    beforeEnter: protectedRoutes,
    meta: {
      title: "Conversations Analytics",
    },
  },
  {
    path: "/messages-analytics",
    name: "MessagesAnalyticsView",
    component: MessagesAnalyticsView,
    beforeEnter: protectedRoutes,
    meta: {
      title: "Messages Analytics",
    },
  },
  {
    path: "/attachments-analytics",
    name: "AttachmentsAnalyticsView",
    component: AttachmentsAnalyticsView,
    beforeEnter: protectedRoutes,
    meta: {
      title: "Attachments Analytics",
    },
  },
  {
    path: "/agent-analytics/:agentId",
    name: "AgentAnalyticsView",
    component: AgentAnalyticsView,
    beforeEnter: protectedRoutes,
    meta: {
      title: "Agent Analytics",
    },
    props: true,
  },
  {
    path: "/analytics/engagement",
    name: "EngagementAnalyticsView",
    component: EngagementAnalyticsView,
    beforeEnter: protectedRoutes,
    meta: {
      title: "Conversations",
    },
  },
  {
    path: "/analytics/agents",
    name: "AgentsAnalyticsView",
    component: AgentsAnalyticsView,
    beforeEnter: protectedRoutes,
    meta: {
      title: "Agents Analytics",
    },
  },
  {
    path: "/analytics/attachments",
    name: "AttachmentsBoardView",
    component: AttachmentsBoardView,
    beforeEnter: protectedRoutes,
    meta: {
      title: "Stocks",
    },
  },
  {
    path: "/analytics/devices/:deviceId?",
    name: "DevicesAnalyticsView",
    component: DevicesAnalyticsView,
    beforeEnter: protectedRoutes,
    meta: {
      title: "Devices Analytics",
    },
  },
  {
    path: "/analytics/cart",
    name: "CartAnalyticsView",
    component: CartAnalyticsView,
    beforeEnter: protectedRoutes,
    meta: {
      title: "Cart Activity",
    },
  },
  {
    path: "/companies",
    name: "CompaniesListView",
    component: CompaniesListView,
    beforeEnter: beforeEnterAllCompanies,
    meta: {
      title: "Companies",
    },
  },
  {
    path: "/company-details",
    name: "CompanyDetailsView",
    component: CompanyDetailsView,
    beforeEnter: protectedRoutes,
    meta: {
      title: "Company Details",
      alignSidebar: true,
    },
  },
  {
    path: "/configurations",
    name: "ConfigurationsView",
    component: ConfigurationsView,
    beforeEnter: protectedRoutes,
    meta: {
      title: "Configurations",
      breadcrumb: [
        { text: "Overview", to: "/overview" },
        { text: "Device Configurations", active: true },
      ],
    },
  },
  {
    path: "/configurations/:id",
    name: "configSettings",
    component: configSettings,
    beforeEnter: protectedRoutes,
    meta: {
      title: "Configuration Settings",
    },
  },
  {
    path: "/general-settings",
    name: "GeneralSettingsView",
    component: GeneralSettingsView,
    beforeEnter: protectedRoutes,
    meta: {
      title: "General Settings",
    },
  },
  {
    path: "/inbox",
    name: "InboxView",
    component: InboxView,
    beforeEnter: protectedRoutes,
    meta: {
      title: "Inbox",
    },
  },
  {
    path: "/session-history/:id",
    name: "SessionHistoryView",
    component: SessionHistoryView,
    meta: {
      title: "Session History",
    },
  },
  {
    path: "/themes",
    name: "ThemesView",
    component: ThemesView,
    beforeEnter: protectedRoutes,
    meta: {
      title: "Themes",
      breadcrumb: [
        { text: "Overview", to: "/overview" },
        { text: "Configurations", to: "/configurations" },
        { text: "Themes Settings", active: true },
      ],
    },
  },
  {
    path: "/themes/:id",
    name: "themeBuilder",
    component: themeBuilder,
    beforeEnter: protectedRoutes,
    meta: {
      title: "Theme Builder",
    },
  },
  {
    path: "/themes/assignments/:id",
    name: "ThemeAssignmentsView",
    component: ThemeAssignmentsView,
    beforeEnter: protectedRoutes,
    meta: {
      title: "Assignments",
    },
  },
  {
    path: "/media-library",
    name: "MediaLibraryView",
    component: MediaLibraryView,
    beforeEnter: protectedRoutes,
    meta: {
      title: "Media Library",
      breadcrumb: [
        { text: "Overview", to: "/overview" },
        { text: "Configurations", to: "/configurations" },
        { text: "Media Library", active: true },
      ],
    },
  },
  {
    path: "/media-library/create",
    name: "createNewMedia",
    component: createNewMedia,
    beforeEnter: protectedRoutes,
    meta: {
      title: "Create New Media",
    },
  },
  {
    path: "/campaigns",
    name: "CampaignsView",
    component: CampaignsView,
    beforeEnter: protectedRoutes,
    meta: {
      title: "Campaigns",
      breadcrumb: [
        { text: "Overview", to: "/overview" },
        { text: "Configurations", to: "/configurations" },
        { text: "Campaigns", active: true },
      ],
    },
  },
  {
    path: "/campaigns/create",
    name: "createCampaign",
    component: createCampaign,
    beforeEnter: protectedRoutes,
    meta: {
      title: "Create Campaign",
    },
  },
  {
    path: "/campaigns/:id",
    name: "editCampaign",
    component: createCampaign,
    beforeEnter: protectedRoutes,
    meta: {
      title: "Edit Campaign",
    },
  },

  {
    path: "/data-library",
    name: "DataLibraryView",
    component: DataLibraryView,
    beforeEnter: protectedRoutes,
    meta: {
      title: "Data Library",
      breadcrumb: [
        { text: "Overview", to: "/overview" },
        { text: "Knowledge Base" },
        { text: "Data Library", active: true },
      ],
    },
  },
  {
    path: "/data-library/upload",
    name: "uploadFiles",
    component: uploadFiles,
    beforeEnter: protectedRoutes,
    meta: {
      title: "Upload Files",
    },
  },
  {
    path: "/overview",
    name: "OverviewView",
    component: OverviewView,
    beforeEnter: protectedRoutes,
    meta: {
      title: "Overview",
    },
  },
  // {
  //   path : '/apps-library',
  //   name : 'AppsLibraryView',
  //   component : AppsLibraryView,
  //   beforeEnter: protectedRoutes,
  //   meta: {
  //     title: 'Apps Library',
  //   }
  // }
  // {
  //   path: '/remote-control',
  //   name: 'RemoteControlView',
  //   component: RemoteControlView,
  //   beforeEnter: protectedRoutes,
  //   meta: {
  //     title: 'Remote Control',
  //   }
  // },
];

export default routes;
